module.exports = __webpack_public_path__ + "img/change-currency.0dfe9d95.png";